import * as React from "react";
const SvgModules20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "black",
        viewBox: "0 0 16 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v7h9V0H1Zm1 5V2h5v3H2ZM1 9H0v7h5V9H1Zm1 5v-3h1v3H2Zm9-14h5v7h-5V0Zm2 2v3h1V2h-1ZM8 9H7v7h9V9H8Zm1 5v-3h5v3H9Z",
      clipRule: "evenodd"
    })
  );
export default SvgModules20Px;
